module.exports = __webpack_public_path__ + "img/ico-pro.975df5ad.png";